export const HERO24_CUT_DEFAULT = 20
